module.exports = __webpack_public_path__ + "assets/pauseTrip.ff5e23e8.svg";